const handleDownloads = e => {
  e.preventDefault();
  const target = e.currentTarget;
  let fileName = target.getAttribute('href').replace(/\/$/, '');

  window.dataLayer.push({
    event: 'interactionsFileDownload',
    fileTitle: fileName.substring(fileName.lastIndexOf('/') + 1),
  });

  window.open(target.getAttribute('href'), '_blank');
};

const handleOutboundLinks = e => {
  const target = e.currentTarget;
  let url = target.getAttribute('href');
  if (location.hostname !== target.hostname && target.hostname.length > 0) {
    window.dataLayer.push({
      event: 'interactionsOutboundLink',
      url: url,
    });
  }
};

const handleSalesContactSelect = e => {
  const target = e.currentTarget;
  const selectedCountry = target.options[target.selectedIndex].innerText;
  const pageHeading = document.querySelector('h1').innerHTML;

  window.dataLayer.push({
    event: 'interactionsSalesContact',
    productName: pageHeading,
    formName: 'Sales',
    country: selectedCountry,
  });
};

const handleContactFormSubmit = (e, wrapper) => {
  e.preventDefault();

  const target = e.currentTarget;
  const selectInput = target.querySelector('select'); //Inget bra att selecta mot här
  const selectedCountry =
    selectInput.options[selectInput.selectedIndex].innerText;
  const formName = wrapper.querySelector('h2').innerHTML;

  window.dataLayer.push({
    event: 'interactionsFormSubmit',
    productName: formName,
    formName: 'Sales',
    country: selectedCountry,
  });

  target.submit();
};

const handleContactFormSubmitError = (e, wrapper) => {
  const contactForm = wrapper.querySelector('form');
  const formName = wrapper.querySelector('h2').innerHTML;
  const selectInput = contactForm.querySelector('select'); //Inget bra att selecta mot här
  const selectedCountry =
    selectInput.options[selectInput.selectedIndex].innerText;
  const invalidElements = contactForm.querySelectorAll('input:invalid');

  if (invalidElements.length > 0) {
    const errorMessage = invalidElements[0].validationMessage;

    window.dataLayer.push({
      formName: formName,
      country: selectedCountry,
      formError: errorMessage,
      event: 'interactionsFormError',
    });
  }
};

const handleTextImageBlockLinkClick = (e, block) => {
  e.preventDefault();

  const target = e.target;
  const title = block.querySelector('h2').innerHTML;
  const url = target.href;

  window.dataLayer.push({
    ctaButtonName: title,
    event: 'interactionsCtaButton',
  });

  window.location = url;
};

const handleDataSheetSubmitClick = e => {
  const target = e.target;
  const countrySelect = target.querySelector('#country_code');
  const selectedCountry =
    countrySelect.options[countrySelect.selectedIndex].innerText;
  const pageHeader = document.querySelector('h1').innerHTML;

  window.dataLayer.push({
    productName: pageHeader,
    country: selectedCountry,
    event: 'interactionsProductDataSheetDownload',
  });
};

const handleDataSheetErrorSubmit = (e, form) => {
  const invalidElements = form.querySelectorAll('input:invalid');
  const countrySelect = form.querySelector('#country_code');
  const selectedCountry =
    countrySelect.options[countrySelect.selectedIndex].innerText;
  const pageHeader = document.querySelector('h1').innerHTML;

  if (invalidElements.length > 0) {
    window.dataLayer.push({
      productName: pageHeader,
      country: selectedCountry,
      event: 'interactionsProductDataSheetFormError',
    });
  }
};

const handleSafetyDataSheetDownload = (e, form) => {
  const pageHeader = document.querySelector('h1').innerHTML;
  const regionSelect = form.querySelector('.js-safetysheet-downloadlink');
  const selectedRegion = regionSelect.options[regionSelect.selectedIndex];

  if (!selectedRegion.hasAttribute('disabled')) {
    window.dataLayer.push({
      productName: pageHeader,
      region: selectedRegion.innerHTML,
      event: 'interactionsSafetyDataSheetDownload',
    });
  } else {
    window.dataLayer.push({
      productName: pageHeader,
      region: selectedRegion.innerHTML,
      event: 'interactionsSafetyDataSheetFormError',
    });
  }
};

const handleMailtoAndTelLinkClick = e => {
  const target = e.target;
  const url = target.href;
  const block = target.closest('.contactarealistblock');
  let selectedCountry = '';

  if (block) {
    const select = block.querySelector('.js-contact-country-select');
    selectedCountry = select.options[select.selectedIndex].innerHTML;
  }

  const event = url.includes('mailto:')
    ? 'interactionsEmail'
    : 'interactionsTelephone';

  window.dataLayer.push({
    event: event,
    country: selectedCountry,
    url: url,
  });
};

const init = () => {
  window.dataLayer = window.dataLayer || [];

  //1.0 - File downloads
  const documentLinks = [
    ...document.querySelectorAll(
      'a[href*=".pdf"], a[href*=".doc"], a[href*=".docx"], a[href*=".xls"], a[href*=".xlxs"]',
    ),
  ];

  if (documentLinks.length > 0) {
    documentLinks.forEach(documentLink => {
      documentLink.addEventListener('click', handleDownloads);
    });
  }

  //1.1 - Outbound links
  const links = [...document.querySelectorAll('a')];

  if (links.length > 0) {
    links.forEach(link => {
      link.addEventListener('click', handleOutboundLinks);
    });
  }

  ////1.2 - Sales contact
  const contactCountrySelects = document.querySelectorAll(
    '.js-contact-country-select',
  );

  if (contactCountrySelects.length > 0) {
    contactCountrySelects.forEach(select => {
      select.addEventListener('change', handleSalesContactSelect);
    });
  }

  //1.3 - Contact form submit
  const contactFormWrappers = document.querySelectorAll(
    '[id*="toggle-support-form"]',
  );

  if (contactFormWrappers.length > 0) {
    contactFormWrappers.forEach(formWrapper => {
      const contactForm = formWrapper.querySelector('form');

      if (contactForm) {
        contactForm.addEventListener('submit', function (e) {
          handleContactFormSubmit(e, formWrapper);
        });
      }
    });
  }

  //1.4 - Contact form error
  if (contactFormWrappers.length > 0) {
    contactFormWrappers.forEach(formWrapper => {
      const submitBtn = formWrapper.querySelector('[type="submit"]');

      if (submitBtn) {
        submitBtn.addEventListener('click', function (e) {
          handleContactFormSubmitError(e, formWrapper);
        });
      }
    });
  }

  //CTA button 1.5
  const imageTextBlocks = [...document.querySelectorAll('.imagetextblock')];

  if (imageTextBlocks.length > 0) {
    imageTextBlocks.forEach(block => {
      const links = block.querySelectorAll('.link-arrow');

      if (links.length > 0) {
        links.forEach(link => {
          link.addEventListener('click', function (e) {
            handleTextImageBlockLinkClick(e, block);
          });
        });
      }
    });
  }

  //1.6 - Newsletter Sign Up
  //NewsletterScript.cshtml

  //1.7 - product data sheet submit
  const dataSheetForm = document.querySelector('.js-datasheet-form');

  if (dataSheetForm) {
    dataSheetForm.addEventListener('submit', handleDataSheetSubmitClick);
  }

  //1.8 - product data sheet form error
  if (dataSheetForm) {
    const dataSheetFormSubmitBtn = dataSheetForm.querySelector(
      'input[type="submit"]',
    );

    if (dataSheetFormSubmitBtn) {
      dataSheetFormSubmitBtn.addEventListener('click', function (e) {
        handleDataSheetErrorSubmit(e, dataSheetForm);
      });
    }
  }

  //1.9 Interactions – Safety Data Sheet - Download
  //1.10 Interactions – Safety Data Sheet - Form error
  let safetyDataSheetForm = document.querySelector('.js-safety-sheet-form');

  if (safetyDataSheetForm) {
    const downloadBtn = safetyDataSheetForm.querySelector('[type="submit"]');

    if (downloadBtn) {
      downloadBtn.addEventListener('click', function (e) {
        handleSafetyDataSheetDownload(e, safetyDataSheetForm);
      });
    }
  }

  //Video 1.11
  //videoblock.js

  //1.12 - Email
  //1.13 - Telephone

  const mailtoLinks = document.querySelectorAll(
    'a[href^="mailto:"], a[href^="tel:"]',
  );

  if (mailtoLinks.length > 0) {
    mailtoLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        handleMailtoAndTelLinkClick(e);
      });
    });
  }
};

const tracking = {
  init,
};

export default tracking;
